import React from 'react';

import { Heading } from '@zillow/constellation';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function PropertyOwner({ section, setSection, setSectionValues }: Props): JSX.Element {
  const maxPeople = 1;

  return (
    <>
      <Heading level={6} marginBottom="sm">
        Is the landlord or managing agent of the property different from the owner, or owner’s agent?
      </Heading>
      <PeopleInformation
        yesAndNoText="Enter the information of either the owner or a person authorized to act on behalf of the owner"
        isOptional
        maximumPeople={maxPeople}
        initialPeople={0}
        personType={PERSON_TYPE.PROPERTY_OWNER}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        addressLabel="Address"
      />
    </>
  );
}
